import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

export function useApiKeys() {
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth();

  // Admin sees all keys (companyId = "sound-admin"), partner sees own
  const companyId = user?.companyId;

  const fetchKeys = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);

    try {
      const res = await makeApiRequest(
        "get",
        apiRoutes.getApiKeys,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );
      setKeys(res.data?.data ?? res.data ?? []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, user?.id, user?.accessToken]);

  useEffect(() => {
    fetchKeys();
  }, [fetchKeys]);

  return { keys, loading, error, refetch: fetchKeys };
}
